import { Link } from 'react-router-dom'
import { Crumb, breadcrumbListJsonLdText } from '../lib/internal_links'
import '../stylesheets/InternalLinks.scss'

type Props = Readonly<{
  crumbs: readonly Crumb[]
  label: string
}>

const Breadcrumbs = ({ crumbs, label }: Props) => {
  if (crumbs.length === 0) return null

  return (
    <nav className="breadcrumbs" aria-label={ label }>
      <ol>
        {
          crumbs.map((crumb, index) => {
            const current = index === crumbs.length - 1

            return (
              <li key={ `${crumb.path}-${index}` }>
                {
                  current
                    ? <span aria-current="page">{ crumb.name }</span>
                    : <Link to={ crumb.path }>{ crumb.name }</Link>
                }
              </li>
            )
          })
        }
      </ol>
      <script type="application/ld+json" dangerouslySetInnerHTML={ { __html: breadcrumbListJsonLdText(crumbs) } } />
    </nav>
  )
}

export { Breadcrumbs }
